export default "__VITE_ASSET__Cuf7dB33__"